export default "__VITE_PUBLIC_ASSET__a747ba28__"